import Popup from "reactjs-popup";
import styled from "styled-components";

export const RightPanel = styled(Popup)`
    &-overlay {
        top: auto !important;
        left: auto !important;
    }
    &-content {
        height: calc(100vh - 51px);
        width: 358px;
        border: 1px solid ${(props) => props.theme.colors["paz-black-l-30"]};
        box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
        background: ${(props) => props.theme.colors["canvas-mid"]};
    }
`;
